import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';
import { initWebVitals } from './reportWebVitals';
import { getAnalyticsConsent } from './utils/consent';
import { startDevLcpObserver } from './utils/devLcpObserver';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Dev-only: log LCP candidate element/size to tune skeletons
startDevLcpObserver();

// Register a lightweight service worker for production builds
if (
  process.env.NODE_ENV === 'production' &&
  'serviceWorker' in navigator &&
  !/reactsnap/i.test(navigator.userAgent || '')
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// Initialize Core Web Vitals reporting
initWebVitals((metric) => {
  try {
    if (typeof window === 'undefined' || !window.gtag) return;
    if (getAnalyticsConsent() !== 'granted') return;

    const name = metric?.name;
    if (!name) return;

    // GA4 expects integers; CLS is a small fractional number -> scale
    const value = name === 'CLS' ? Math.round(metric.value * 1000) : Math.round(metric.value);

    window.gtag('event', 'web_vitals', {
      value,
      metric_name: name,
      metric_id: metric.id,
      metric_rating: metric.rating,
      non_interaction: true,
    });
  } catch {}
});
